var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.001h-3v10h-18v-10h-3l12-12.001 12 12.001zm-19-2.172v10.172h14v-10.172l-7-7-7 7zm10.332 8.043s-3.953-4.159-4.148-4.354c-.463-.464-1.003-.333-1.285-.051-.398.398-.037 1.019-.037 1.019l-.874.875-2.474-2.474.875-.874s.607.433 1.114-.074c.552-.552.301-1.288 1.525-2.21.726-.547 1.576-.728 2.384-.728 1.591 0 3.019.703 3.019.703-2.581.258-3.607 1.453-2.54 2.52l3.995 4.318c.808.808-.476 2.408-1.554 1.33zm4.668-16.871v5.576l-3-3v-2.576h3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFix);
export default __webpack_public_path__ + "static/media/fix.b6557d9e.svg";
export { ForwardRef as ReactComponent };